import { Injectable } from '@angular/core';
import {HttpClient, HttpHeaders, HttpParams} from '@angular/common/http';
import {Observable} from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class SclExportService {

  format = 'csv';
  headers = [];

  constructor(private  httpClient: HttpClient) { }

  export(qry: any, filename: string, settings: any, handlebarsHelpers: any, contextParams: any ): Observable<any> {

    const type = this.format;
    filename = filename  + '.' + type;

    if (!this.headers) {
      this.headers = [{title: 'ID', field: 'documentId'}, {title: 'name', field: 'systemHeader.summaryName'}];
    }

    const safeHelpers = (handlebarsHelpers || []).map(helper => ({
      name: helper.name,
      function: typeof helper.function === 'function'
        ? helper.function.toString()
        : helper.function
    }));

    const body = {
        headers: this.headers,
        query: qry,
        fileName: filename,
        type: type,
        size: settings?.size || 'A4',
        layout: settings?.layout || 'landscape',
        fontSize: settings?.fontSize || 10,
        margin: settings?.margin && settings?.margin <= 100 ? settings?.margin : 25,
        headerFontSize: settings?.headerFontSize || 8,
        columnSpacing: settings?.columnSpacing || 5,
        urlExportMode: settings?.urlExportMode || 'linkObject',
        // handlebarsHelpers: safeHelpers || [],
        stripHTML: settings?.stripHTML ?? true,
        document: contextParams.document ?? null,
        componentDefinition: contextParams.componentDefinition,
        account: contextParams.account
      };

    console.log('asccex', body);
    const getJsonSize = (jsonData: any): number => {
      const jsonString = JSON.stringify(jsonData);
      return new Blob([jsonString]).size; // size in bytes
    }

    const options = {
      headers: new HttpHeaders({'Content-Type': 'application/json'}),
      responseType: 'blob' as 'json'
    };

    return this.httpClient.post('/api/searchExport', body, options );
  }

}
